<template>
  <v-form ref="SALAIRE_MEANS" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="SALAIRE_MEANS">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <payment-means-summary v-if="isDisplayed('SALAIRE_MEANS_ID')"
                               ref="SALAIRE_MEANS_ID"
                               :theme="theme"
                               :showMissing="showMissing"
                               v-model:value=salaireMeansId
                               :moduleId=moduleId
                               libelle="'Moyen de paiement'"
                               newLabel=''
                               selectText=""
                               @status=statusSalaireMeansId
                               :autoClear=true
                               :owner="owner"
                               :requiredAttributs="requiredAttributs"
                               :autoSelect=true
                               :ressource=ressourcePaymentMeansSummary
                               :filters=salaireMeansIdFilter
                               :toggleReset=resetSalaireMeansId
                               :required="isRequired('SALAIRE_MEANS_ID')"
                               :contextId=etablissement.id
                               :readOnly="readOnly('SALAIRE_MEANS_ID')"
                               :objType=objType
                               :fiche=fiche
                               :sectionName="sectionName">
        </payment-means-summary>
        <etablissement-payment-auto-salaire v-if="isDisplayed('PAYMENT_AUTO_SALAIRE')"
                                            ref="PAYMENT_AUTO_SALAIRE"
                                            :theme="theme"
                                            :showMissing="showMissing"
                                            v-model:value=paymentAutoSalaire
                                            @status=statusPaymentAutoSalaire
                                            :required="isRequired('PAYMENT_AUTO_SALAIRE')"
                                            :contextId=etablissement.id
                                            :readOnly="readOnly('PAYMENT_AUTO_SALAIRE')"
                                            :objType=objType
                                            :fiche=fiche
                                            :sectionName="sectionName">
        </etablissement-payment-auto-salaire>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import CrudEtablissement from '@/generated/cruds/CrudEtablissement';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import Owner from '@/extend/classes/Owner';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    extends:  CrudEtablissement,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
      isAbstract: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.SALAIRE_MEANS,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },

      ressourcePaymentMeansSummary () { return RessourceGenControl(GenControl.SALAIRE_MEANS_PAYMENT_MEANS_SUMMARY); },

      ressource () { return RessourceGenSection(GenSection.SALAIRE_MEANS); },

      owner (): Owner {
        const owner = new Owner();
        owner.objType = ObjTypes.ETABLISSEMENT;
        owner.objId = this.editEtablissement.id;
        return owner;
      },

      fields (): string[] {
        return ['SALAIRE_MEANS_ID', 'PAYMENT_AUTO_SALAIRE'];
      },

      extraButtons (): Button[] {
        return [];
      },

      salaireMeansIdFilter (): ColumnFilter[] {
        const res: ColumnFilter[] = [];
        return res;
      },
    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);;
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editEtablissement.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("SALAIRE_MEANS_ID", false);
          this.readOnlyMap.set("PAYMENT_AUTO_SALAIRE", false);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("SALAIRE_MEANS_ID", true);
          this.displayMap.set("PAYMENT_AUTO_SALAIRE", true);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("SALAIRE_MEANS_ID", true);
          this.requiredMap.set("PAYMENT_AUTO_SALAIRE", true);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoMeans' 
      },

      sectionSave (): void {
        return this.save();
      }
    }
  })
</script>
